import React from "react";

export const FinanceIllustration = () => (
    <svg viewBox="0 0 400 350" fill="none" xmlns="http://www.w3.org/2000/svg">
        <defs>
            <filter id="cardShadow" x="-15%" y="-10%" width="130%" height="130%">
                <feDropShadow dx="0" dy="6" stdDeviation="10" floodColor="rgba(0,0,0,0.12)"/>
            </filter>
            <filter id="smallShadow" x="-20%" y="-20%" width="140%" height="140%">
                <feDropShadow dx="0" dy="3" stdDeviation="6" floodColor="rgba(0,0,0,0.08)"/>
            </filter>
        </defs>

        {/* Subtle background circles */}
        <circle cx="200" cy="175" r="130" fill="rgba(255,255,255,0.04)" />
        <circle cx="200" cy="175" r="90" fill="rgba(255,255,255,0.03)" />

        {/* Main dashboard card */}
        <g filter="url(#cardShadow)">
            <rect x="65" y="45" width="230" height="180" rx="14" fill="white"/>
        </g>
        <rect x="65" y="45" width="230" height="44" rx="14" fill="#0a4940"/>
        <rect x="65" y="75" width="230" height="14" fill="#0a4940"/>
        <circle cx="88" cy="67" r="5" fill="#ff6b6b" opacity="0.9"/>
        <circle cx="104" cy="67" r="5" fill="#ffd93d" opacity="0.9"/>
        <circle cx="120" cy="67" r="5" fill="#4ecca3" opacity="0.9"/>

        {/* Bar chart */}
        <rect x="90" y="170" width="24" height="35" rx="4" fill="#e8eff5"/>
        <rect x="124" y="148" width="24" height="57" rx="4" fill="#e8eff5"/>
        <rect x="158" y="125" width="24" height="80" rx="4" fill="#4ecca3"/>
        <rect x="192" y="140" width="24" height="65" rx="4" fill="#e8eff5"/>
        <rect x="226" y="115" width="24" height="90" rx="4" fill="#0d5a52" opacity="0.7"/>
        <rect x="260" y="138" width="24" height="67" rx="4" fill="#e8eff5"/>

        {/* Trend line */}
        <polyline
            points="102,160 136,142 170,120 204,133 238,110 272,128"
            stroke="#4ecca3" strokeWidth="2.5" fill="none"
            strokeLinecap="round" strokeLinejoin="round" opacity="0.7"
        />

        {/* Floating invoice card */}
        <g transform="translate(270, 130) rotate(-6)">
            <g filter="url(#smallShadow)">
                <rect width="105" height="140" rx="10" fill="white"/>
            </g>
            <rect x="14" y="14" width="77" height="7" rx="3.5" fill="#0d5a52" opacity="0.75"/>
            <rect x="14" y="28" width="48" height="5" rx="2.5" fill="#e0e0e0"/>
            <rect x="14" y="46" width="77" height="4" rx="2" fill="#f0f0f0"/>
            <rect x="14" y="57" width="55" height="4" rx="2" fill="#f0f0f0"/>
            <rect x="14" y="68" width="65" height="4" rx="2" fill="#f0f0f0"/>
            <rect x="14" y="79" width="40" height="4" rx="2" fill="#f0f0f0"/>
            <line x1="14" y1="93" x2="91" y2="93" stroke="#eee" strokeWidth="1"/>
            <rect x="48" y="103" width="43" height="18" rx="9" fill="#4ecca3" opacity="0.9"/>
            <circle cx="28" cy="112" r="9" fill="#4ecca3" opacity="0.15"/>
            <path d="M23.5 112 L26.5 115 L33 108.5" stroke="#4ecca3" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </g>

        {/* Stats mini card */}
        <g transform="translate(290, 38)">
            <g filter="url(#smallShadow)">
                <rect width="82" height="58" rx="10" fill="white"/>
            </g>
            <rect x="12" y="11" width="38" height="5" rx="2.5" fill="#e0e0e0"/>
            <rect x="12" y="22" width="50" height="12" rx="3" fill="#4ecca3" opacity="0.12"/>
            <polyline points="12,47 24,41 36,44 48,37 62,32" stroke="#4ecca3" strokeWidth="2" fill="none" strokeLinecap="round"/>
        </g>

        {/* Mini pie chart card */}
        <g transform="translate(15, 195)">
            <g filter="url(#smallShadow)">
                <rect width="72" height="62" rx="10" fill="white"/>
            </g>
            <circle cx="36" cy="28" r="16" fill="#e8eff5"/>
            <path d="M36 12 A16 16 0 0 1 50.8 34.8 L36 28 Z" fill="#4ecca3"/>
            <path d="M36 12 A16 16 0 0 0 21.2 34.8 L36 28 Z" fill="#0d5a52" opacity="0.7"/>
            <rect x="10" y="51" width="52" height="3" rx="1.5" fill="#e0e0e0"/>
        </g>

        {/* Floating coin */}
        <g filter="url(#smallShadow)">
            <circle cx="40" cy="110" r="20" fill="#ffd93d" opacity="0.9"/>
        </g>
        <circle cx="40" cy="110" r="14" fill="#ffd93d"/>
        <circle cx="40" cy="110" r="14" stroke="#e6c235" strokeWidth="1.5" fill="none"/>

        {/* Decorative dots */}
        <circle cx="350" cy="300" r="5" fill="rgba(255,255,255,0.15)"/>
        <circle cx="380" cy="170" r="3" fill="rgba(78,204,163,0.3)"/>
        <circle cx="20" cy="55" r="4" fill="rgba(255,255,255,0.1)"/>
        <circle cx="355" cy="95" r="3" fill="rgba(255,255,255,0.2)"/>
    </svg>
);

export const FloatingShapes = () => (
    <div className="floating-shapes">
        <div className="shape shape-1"></div>
        <div className="shape shape-2"></div>
        <div className="shape shape-3"></div>
        <div className="shape shape-4"></div>
        <div className="shape shape-5"></div>
        <div className="shape shape-6"></div>
    </div>
);
